import { DndContext } from '@dnd-kit/core';
import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import type { ProposalExtraItemType } from '@econtractor/types';
import useSortableTableDnd from '../model/useSortableTableDnd';
import AdditionalItemsTableBody from './AdditionalItemsTableBody';
import useAdditionalItemsTable from './model/useAdditionalItemsTable';

interface AdditionalItemsTableProps {
    items: ProposalExtraItemType[];
    rate: number;
    localeNs: string;
    disabled: boolean;
    onChange: (items: ProposalExtraItemType[]) => void;
}

const AdditionalItemsTable = ({ items, rate, localeNs, disabled, onChange }: AdditionalItemsTableProps) => {
    const { t } = useTranslation([localeNs]);
    const table = useAdditionalItemsTable({ items, rate, onChange });
    const dnd = useSortableTableDnd({
        onDragStart: table.clearInlineEdits,
        onReorder: table.reorderByIds,
    });

    const tableNode = (
        <div className="proposal-additional-table-wrap">
            <Table size="sm" className="ComingTable ProposalAdditionalTable table-hover mb-0">
                <thead>
                    <tr className="bg-light">
                        {!disabled ? <td className="head-drag" /> : null}
                        <td className="head-name">{t('edit.additional.tableItem')}</td>
                        <td className="head-price">{t('edit.additional.tablePrice')}</td>
                        <td className="head-count text-end">{t('edit.additional.tableCount')}</td>
                        {!disabled ? <td className="head-action text-end">{t('edit.additional.tableActions')}</td> : null}
                    </tr>
                </thead>
                <AdditionalItemsTableBody
                    items={items}
                    rate={rate}
                    localeNs={localeNs}
                    disabled={disabled}
                    table={table}
                    sortable={!disabled}
                />
            </Table>
        </div>
    );

    if (disabled) return tableNode;

    return (
        <DndContext
            sensors={dnd.sensors}
            collisionDetection={dnd.collisionDetection}
            onDragStart={dnd.handleDragStart}
            onDragEnd={dnd.handleDragEnd}
        >
            {tableNode}
        </DndContext>
    );
};

export default AdditionalItemsTable;
